<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="d-flex justify-content-end">
    <div class="d-flex gap-3">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
            (keydown.enter)="openReport('Pdf')">
            <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.isAuditTrailUser" (click)="openAuditTrail()" (keydown.enter)="openAuditTrail()">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Audit Trail</span>
        </div>
    </div>
</div>

<div class="row" style="margin: 10px;">
    <div class="row question-and-answer-header" style="color: #005C8A;"
        [style.grid-template-columns]="getColumnSizes()">
        <span class="mx-3">
            Risk Category
        </span>
        <span class="mx-3">
            Risk Name <span class="mandatory-symbol">*</span>
        </span>
        <span class="mx-3">
            Risk Scale
        </span>
        <span class="mx-2">
            Comments
        </span>
    </div>

    <div class="row" *ngFor="let risk of riskSettings; let idx = index;" style="margin: 10px; margin-bottom: -15px;">
        <div class="row question-and-answer-body" [ngStyle]="{'background':idx % 2 === 0?'':'white'}"
            [style.grid-template-columns]="getColumnSizes()">
            <div>
                <mat-select matInput placeholder="Select" [(ngModel)]="risk.selectedRiskCategory"
                    (closed)="riskCategorysearchTxt=''" (click)="focusMethod('riskCategorySearch')"
                    (keydown.enter)="focusMethod('riskCategorySearch')"
                    [ngClass]="{'odd-item-mat-select':risk.idOddValue}" [disabled]="true">
                    <input type="search" id="riskCategorySearch" class="dropdownsearchstyle"
                        [(ngModel)]="riskCategorysearchTxt" matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of riskCategoryDropdown| assessmentSearch :riskCategorysearchTxt"
                        (onSelectionChange)="onRiskCategorySelect($event,item)" [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div>
                <mat-select matInput placeholder="Select" [(ngModel)]="risk.selectedriskCategoryNameValue"
                    (closed)="isriskCategoryNameValuesearchTxt=''"
                    (click)="focusMethod('riskCategoryNameValuesearchTxtSearch')"
                    (keydown.enter)="focusMethod('riskCategoryNameValuesearchTxtSearch')"
                    [ngClass]="{'odd-item-mat-select': risk.idOddValue, 'invalid-field': risk.isInvalid}"
                    [disabled]="!isFrozen">
                    <input type="search" id="riskCategoryNameValuesearchTxtSearch" class="dropdownsearchstyle"
                        [(ngModel)]="isriskCategoryNameValuesearchTxt" matInput placeholder="search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option
                        *ngFor="let item of risk.riskCategoryNameList| assessmentSearch :isriskCategoryNameValuesearchTxt"
                        (onSelectionChange)="onRiskNameSelect($event,item,idx)" [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>

            <span>
                <input type="text" style="cursor: not-allowed;" class="col-md-6 input-filed-continers"
                    [(ngModel)]="risk.riskCategoryScale" [disabled]="true">
            </span>
            <span>
                <input class="col-md-6 input-filed-continers" type="text" [(ngModel)]="risk.comments"
                    [disabled]="!isFrozen">
            </span>
        </div>
    </div>
</div>

<div *ngIf="isFrozen">
    <div class="button-continer btn-align" mat-dialog-actions style="margin: 10px;justify-content: center;">
        <div class="col-sm-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
            style="color:white;" (click)="calculateValidation()" (keydown.enter)="calculateValidation()">
            <i class="fas fa-user-edit" style="font-size: 18px;color:white;"></i>
            <span
                *ngIf="(pagename == 'findings' ||pagename == 'PWfinding') && (this.calculatedRiskValue.finalRiskScore==null && this.calculatedRiskValue.finalRiskStatus==null)">Calculate
                Risk</span>
            <span
                *ngIf="(pagename == 'findings'||pagename == 'PWfinding') && (this.calculatedRiskValue.finalRiskScore!=null || this.calculatedRiskValue.finalRiskStatus!=null)">Re-Calculate
                Risk</span>
            <span
                *ngIf="(pagename != 'findings' && pagename != 'PWfinding') && (this.qualityService.activity.finalRiskScore==null && this.qualityService.activity.finalRiskStatus==null)">Calculate
                Risk</span>
            <span
                *ngIf="(pagename != 'findings' && pagename != 'PWfinding') && ( this.qualityService.activity.finalRiskScore!=null || this.qualityService.activity.finalRiskStatus!=null)">Re-Calculate
                Risk</span>
        </div>
    </div>
</div>
<div class="row" style="margin-top: 10px;justify-content: center;"
    [hidden]="this.calculatedRiskValue.finalRiskScore==null && this.calculatedRiskValue.finalRiskStatus==null">
    <div class="d-flex col-6 pb-2" style="border:0.75px solid #cfcfcf;justify-content: center;">

        <div class="col-md-3">
            <label for="final-score">Final Risk Score</label>
            <input type="text" class=" input-filed-continers" style="cursor: not-allowed;"
                [(ngModel)]="calculatedRiskValue.finalRiskScore" [disabled]="true">
        </div>
        <div class="col-md-3 px-3">
            <label for="final-status">Final Risk Status</label>
            <input type="text" class=" input-filed-continers" style="cursor: not-allowed;"
                [(ngModel)]="calculatedRiskValue.finalRiskStatus" [disabled]="true">
        </div>
        <div class="col-md-6 px-2">
            <label for="final-comments">Final Risk Comments</label>
            <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                [(ngModel)]="calculatedRiskValue.finalRiskComments"
                (change)="finalRiskCommentsChange(calculatedRiskValue.finalRiskComments)"
                [disabled]="!isFrozen"></textarea>
        </div>

    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="calculatedRiskValue.finalRiskScore && isFrozen">
        <button mat-stroked-button class="addButton" (click)="savebutton()">
            <i class="fas fa-user-edit"></i> Save
        </button>
    </div>

</div>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>